import { bool, func } from 'prop-types';
import React from 'react';

import FileDownloader from '../../../generic/FileDownloader';
import { getTooltipButtonWithText } from '../../../generic/Tooltip';
import api from '../../../REST/api';
import withApiRequest from '../../../REST/with-api-request';
import { allStatusesEnum } from '../../constants';
import HELP_TEXTS from '../../help-texts';

const TooltipButtonComponent = getTooltipButtonWithText(HELP_TEXTS);

function ExportInvoicesButton({ onRequest, onSuccess, disabled }) {
  return (
    <FileDownloader
      color="primary"
      disabled={disabled}
      helpKey="export"
      onFileDownloadSuccess={onSuccess}
      onGetFile={() =>
        onRequest({ search: { status: allStatusesEnum.APPROVED.value } })
      } // eslint-disable-line react/jsx-curly-newline
      resource="inv"
      section="statusChanges"
      showTooltip={disabled}
      tag={TooltipButtonComponent}
    >
      Export all approved invoices
    </FileDownloader>
  );
}
ExportInvoicesButton.propTypes = {
  onRequest: func.isRequired,
  onSuccess: func.isRequired,
  disabled: bool.isRequired,
};

export default withApiRequest({
  query: api.exportInvoices,
  error: 'flash',
  successMessage:
    'A copy of the CSV with all approved invoices has been emailed to you.',
})(ExportInvoicesButton);
